import instance from "../axios-instance";

export const getEnums = async (): Promise<EnumData> => {
	return (await instance.get(`app/enums`)).data;
};

export interface EnumData {
	[key: string]: {
		[key: string]: number | string;
	};
}
